module.exports = __webpack_public_path__ + "img/IconHome.4d27e520.svg";